<template>
  <div class="report-fs">
    <!-- <div style="margin-top: 178px;" v-if="pathLogo == m"></div>
        <div style="margin-top: 35px;" v-if="pathLogo != m"></div>
        <div class="mlogo t-alignlogo">
          <img class="wlogo" :src="pathLogo" />
        </div> -->
    <h3 class="text-center fs-head-co">{{ allData.fullName }}</h3>
    <h3 class="text-center fs-head-co">{{ allData.shortName }}</h3>
    <h3 class="text-center fs-head">تقرير البيانات الوظيفية</h3>
    <!-- <h3 class="text-center fs-head"> {{ DepartmentId == "" ? "" : data[0].departmentName }}</h3> -->
    <h4 class="text-left" style="margin-left: 50px; direction: ltr">
      التاريخ : {{ convertToUi(new Date()) }}
    </h4>

    <md-card-content dir="rtl" class="redirect-dir">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card style="box-shadow: none">
            <div
              style="margin-top: 10px; margin-bottom: 35px"
              class="marginTop"
            >
              <md-card-content>
                <md-table
                  class="paginated-table table-striped table-hover mt-25"
                >
                  <md-table-row>
                    <md-table-cell>ر.م</md-table-cell>

                    <md-table-cell class="w-400">الاسم</md-table-cell>

                    <md-table-cell class="w-200">الرقم الوطني</md-table-cell>

                    <md-table-cell class="w-200">الادارة</md-table-cell>

                    <md-table-cell class="w-200">القسم</md-table-cell>

                    <md-table-cell class="w-200">الوحدة</md-table-cell>

                    <md-table-cell class="w-200">الوضع الحالي</md-table-cell>

                    <md-table-cell class="w-200">نوع التوظيف</md-table-cell>
                    <md-table-cell class="w-200">تاريخ المباشرة</md-table-cell>
                    <md-table-cell class="w-200"> الوظيفة </md-table-cell>
                    <md-table-cell class="w-200">مكان العمل</md-table-cell>
                    <md-table-cell class="w-200">الدرجة الحالية</md-table-cell>
                    <md-table-cell class="w-200"
                      >سبب الدرجة الحالية</md-table-cell
                    >
                    <md-table-cell class="w-200"
                      >العلاوة الادارية</md-table-cell
                    >
                    <md-table-cell class="w-200"
                      >تاريخ الدرجة الحالية</md-table-cell
                    >
                    <md-table-cell class="w-200"
                      >شهر العلاوة السنوية</md-table-cell
                    >
                    <md-table-cell class="w-200"
                      >تاريخ استحقاق الترقية</md-table-cell
                    >
                    <md-table-cell class="w-200">الصفة الوظيفية</md-table-cell>
                    <md-table-cell class="w-200">رقم الموظف</md-table-cell>

                    <md-table-cell class="w-200"
                      >الزيادة الشهرية للاجازة السنوية</md-table-cell
                    >

                    <md-table-cell class="w-200">المؤهل العلمي</md-table-cell>

                    <md-table-cell class="w-200">التخصص</md-table-cell>

                    <md-table-cell class="w-200"
                      >جهة اصدار المؤهل</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >سنة الحصول على المؤهل</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >تاريخ قرار التعيين</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >رقم قرار التعيين</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >جهة اصدار التعيين</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >الوضع الوظيفي عند التعيين</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >المؤهل العلمي عند التعيين</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >الدرجة عند التوظيف</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >التخصص عند التعيين</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >رقم الملاك الوظيفي</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >تاريخ شغل الوظيفية</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >طريقة شغل الوظيفة</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >جهة العمل السابقة</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >تاريخ مباشرة العمل بالجهة</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >عدد ايام الاجازات</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >تاريخ صدور قرار النقل</md-table-cell
                    >
                  </md-table-row>
                  <md-table-row v-for="(item, i) in data" :key="i">
                    <md-table-cell md-label="الصنف">{{ i + 1 }}</md-table-cell>

                    <md-table-cell class="w-400" md-label="الصنف">{{
                      item.fullName
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.nationalNumber
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.departmentName
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف"
                      >{{ item.sectionName }}
                    </md-table-cell>

                    <md-table-cell md-label="الصنف"
                      >{{ item.unitName }}
                    </md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.currentSituationString
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.jobTypeString
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      convert(item.startingDate)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.job
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.workplace
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.currentGrade
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.reasonForCurrentGrade
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.currentBonus
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      convert(item.lastGradeUpdate)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.bonusDueDate
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      convert(item.upgradeDueDate)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.jobTitle
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.jobNumber
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.monthlyIncreaseOfVacation
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.scientificDegreeName
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.specialization
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.certificateProviderOrganization
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.scientificDegreeYear
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      convert(item.employmentDate)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.designationDecisionNumber
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.appointment
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.jobStatusAppointment
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.scientificAppointment
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.gradeAppointment
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.specializationAppointment
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.EmploymentNumber
                    }}</md-table-cell>
                    <md-table-cell md-label="الصنف">{{
                      convert(item.jobDate)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.jobDescriptionString
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.previousEmployer
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      convert(item.startingDateAtWork)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.yearlyVecationBalance
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      convert(item.dateTransfer)
                    }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </div>
          </md-card>
        </div>
      </div>
    </md-card-content>
  </div>
</template>
  
<script>
//  import { count } from "console";
import env from "../../../env";

export default {
  mounted() {},
  props: ["data", "pathLogo", "allData", "vacationYear"],
  data() {
    return {
      currentSort: "",
      currentSortOrder: "asc",
      m: env.mTop(),
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (event == null) {
          return "";
        }

        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getDate() + " - " + (d.getMonth() + 1) + " - " + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
.report-fs {
  * {
    font-size: 22px !important;
    font-family: "Cairo", sans-serif !important;
  }

  .md-table-head {
    .md-table-head-container {
      .md-table-head-label {
        font-size: 22px !important;
      }
    }
  }

  .fs-head-co {
    font-size: 29px !important;
    font-weight: bold;
  }

  .fs-head {
    font-size: 25px !important;
  }

  .custom-mt {
    margin-bottom: 440px;
  }

  .border-staffLists {
    border: 1px solid #000;
    /* border-left: none; */
    border-top: 1px solid #000 !important;
    height: 90px;
  }
}
</style>